import { VeType } from './vesTypes'
import { ZoneInfoTemplate } from '../components/enrollForm'

export interface FcInfo {
    name: string
    email: string
    role: string | null
    code: string
    zone_code: string | null
    zone_name: string | null
    zone_sfid?: string | null
    country: string
    is_active: boolean
    ve_villages: { code: string }[]
    phone_number: string | null
}

export type FcMetricsPayload = {
    fc_metrics: {
        fc_code: string
        total_monthly_sales: number
        total_enrolled_this_month: number
        total_active_ids_this_month: number
        total_potential_clients_visited: number
        total_new_clients_registered: number
        total_finishers: number
        total_enrollments_without_payments: number
        total_payments_with_no_enrollment: number
        total_ves: number
        total_villages: number
        total_farmers: number
        total_deposits: number
        total_sales: number
    }
    fc_info: FcInfo
}

export enum VeSearchActionEnum {
    SAVE_VE_SEARCH_RESULTS = 'SAVE_VE_SEARCH_RESULTS'
}

export type VeSearchActionType = {
    type: VeSearchActionEnum.SAVE_VE_SEARCH_RESULTS
    payload?: VeType[]
}

export type VeSearchStateType = {
    results: VeType[]
}

export enum FcHomeEnum {
    PRE_FETCHING_ENROLLMENT_FORM = 'PRE_FETCHING_ENROLLMENT_FORM',
    FETCH_ENROLLMENT_FORM_SUCCESS = 'FETCH_ENROLLMENT_FORM_SUCCESS',
    FETCH_ENROLLMENT_FORM_FAILURE = 'FETCH_ENROLLMENT_FORM_FAILURE'
}


export type ProductListPayload = ZoneInfoTemplate[]

export interface FetchProductListAction {
    type: FcHomeEnum
    payload?: ProductListPayload | string
}

export interface FcHomeActionType {
    type: FcHomeEnum
    payload?: any
}
